export class AddMinorToEventDTO{
    minorId: number[] = [];
    acceptPolicy: boolean = false;

    constructor(data = {}){
        Object.assign(this,data);
    }
}